<template>
  <div class="tabela-valores">
    <div
      v-for="col in colunas"
      :key="col.key"
      class="tabela-valores-titulo"
      :style="col.style"
    >
      <div class="tabela-valores-titulo-Inteiro">
        {{ col.titulo }}
      </div>
    </div>
    <div
      v-for="linha in template.linhas.filter(filtrarLinhaParaExibir)"
      :key="linha.key"
      class="tabela-valores-linha"
      :style="linha.style"
    >
      <div class="tabela-valores-linha-valor">
        {{ linha.titulo }}
      </div>
    </div>
    <div
      v-for="linha in linhasDinamicas.filter(
        (l) => !readonly || (readonly && !!l.valor)
      )"
      :key="linha.key"
      class="tabela-valores-linha"
      :style="linha.style"
    >
      <div class="tabela-valores-linha-valor">
        <span v-if="readonly">{{ linha.valor }}</span>
        <CampoGenerico
          v-else-if="linha.tipoValor === 'Inteiro'"
          :id="linha.key"
          mascara="999999"
          tamanho="sm"
          :valor="linha.valor"
          :exibe-label="false"
          @blur="atualizarValor(linha.key, $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import set from 'lodash/set'

import CampoGenerico from '@/componentes/formulario/CampoGenerico'
import { articulacao } from '@/constantes/evolucao/templates/articulacao'

const flattenObject = (obj, delimiter = '.', prefix = '') =>
  Object.keys(obj).reduce((acc, k) => {
    const pre = prefix.length ? `${prefix}${delimiter}` : ''
    if (
      typeof obj[k] === 'object' &&
      obj[k] !== null &&
      Object.keys(obj[k]).length > 0
    )
      Object.assign(acc, flattenObject(obj[k], delimiter, pre + k))
    else acc[pre + k] = obj[k]
    return acc
  }, {})

export default {
  components: {
    CampoGenerico,
  },
  props: {
    valor: {
      type: Object,
      default: () => ({}),
    },
    readonly: {
      type: Boolean,
      defauilt: false,
    },
  },
  data() {
    return {
      template: cloneDeep(articulacao),
    }
  },
  computed: {
    colunas() {
      return this.template.colunas.filter((col) => {
        if (this.readonly && col.key.startsWith('referencia.')) {
          const temValorDeRef = Object.keys(flattenObject(this.valor)).some(
            (key) => {
              const partialKey = col.key.replace('referencia.', '')
              return key.endsWith(partialKey)
            }
          )

          return temValorDeRef
        }

        return true
      })
    },
    linhasDinamicas() {
      const colunasComTipo = this.template.colunas.filter(
        (col) => !!col.tipoValor
      )
      return colunasComTipo
        .map((col) => {
          return this.template.linhas
            .filter((linha) => !!linha.tipoValor)
            .map((linha) => {
              return {
                key: `${col.key}.${linha.key}`,
                titulo: `${col.key}.${linha.key}`,
                tipoValor: linha.tipoValor,
                valor: get(this.valor, `${col.key}.${linha.key}`),
                style: {
                  gridColumn: col.style.gridColumn,
                  gridRow: linha.style.gridRow,
                },
              }
            })
        })
        .flat()
    },
  },
  methods: {
    atualizarValor(key, valor) {
      if (!valor || !valor.value) return
      const obj = { ...this.valor }
      set(obj, key, valor.value)
      this.$emit('atualizar', obj)
      console.log('>> obj', JSON.stringify(obj, null, 2))
    },
    filtrarLinhaParaExibir(l) {
      if (!this.readonly) return true
      const linhas = this.linhasDinamicas.filter((ld) => {
        return ld.key.includes(l.key) && ld.valor
      })
      return linhas.length > 0
    },
  },
}
</script>

<style scoped>
.tabela-valores {
  display: grid;
  align-items: stretch;
  justify-items: stretch;
  background-color: #ecf0f1;
  padding: 2px;
}

.tabela-valores-titulo,
.tabela-valores-linha {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  font-size: 10pt;
  font-weight: 600;
  color: #008080;
  background-color: white;
  border: 1px solid #ecf0f1;
}

.tabela-valores-titulo-Inteiro,
.tabela-valores-linha-valor {
  margin: 0 auto;
  width: 80px;
}

.tabela-valores-linha-valor > .form-group {
  margin-bottom: 0;
}
</style>
